/**
 * 将Base64字符串转换为PDF Blob并打印或下载
 * @param base64String - PDF的Base64字符串
 * @param filename - 文件名
 */
export const printPdfFromBase64 = (base64String: string, filename: string): void => {
    try {
        // 将Base64字符串转换为Blob
        const binaryString = atob(base64String);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: 'application/pdf' });
        
        // 创建PDF URL
        const pdfUrl = URL.createObjectURL(blob);
        
        // 尝试在新窗口中打开PDF并打印
        const printWindow = window.open(pdfUrl, '_blank');
        if (printWindow) {
            printWindow.onload = () => {
                printWindow.print();
            };
        } else {
            // 如果无法打开新窗口，直接下载PDF
            downloadPdf(pdfUrl, filename);
        }
        
        // 清理URL
        setTimeout(() => {
            URL.revokeObjectURL(pdfUrl);
        }, 1000);
    } catch (error) {
        console.error('Error processing PDF:', error);
        throw new Error('Failed to process PDF for printing');
    }
};

/**
 * 下载PDF文件
 * @param pdfUrl - PDF的Blob URL
 * @param filename - 文件名
 */
export const downloadPdf = (pdfUrl: string, filename: string): void => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};